import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { getReviews } from '../lib/api';

function Home() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getReviews({ limit: 6 })
      .then((data) => setReviews(data.reviews))
      .catch(() => setReviews([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <Seo description="Libros, lugares e historias para viajar entre páginas. Reseñas, recomendaciones de lectura, viajes literarios y el podcast Entre Páginas." />

      <section className="hero">
        <span className="eyebrow">Revista literaria y de viajes</span>
        <h1>Libros, lugares e historias para viajar entre páginas.</h1>
        <p>Reseñas · Recomendaciones · Viajes literarios · Podcast Entre Páginas</p>
        <Link className="cta-button" to="/resenas">Ver últimas reseñas</Link>
      </section>

      <div className="page">
        <div className="section-heading">
          <h2>Últimas lecturas</h2>
          <Link to="/resenas">Ver todas las reseñas →</Link>
        </div>
        {!loading && reviews.length === 0 && (
          <p className="empty-state">
            Todavía no hay reseñas publicadas. En cuanto se den de alta las primeras, aparecerán aquí automáticamente.
          </p>
        )}
        <div className="card-grid">
          {reviews.map((review) => (
            <Link key={review.id} to={`/resenas/${review.slug}`} className="content-card">
              {review.cover_url && <img src={review.cover_url} alt={review.title} />}
              <div className="content-card__body">
                <span className="content-card__category">Reseña</span>
                <h3 className="content-card__title">{review.title}</h3>
                {review.book_title && <p className="content-card__excerpt">{review.book_title}</p>}
              </div>
            </Link>
          ))}
        </div>

        <div className="section-heading">
          <h2>Qué leer</h2>
          <Link to="/que-leer">Ver recomendaciones →</Link>
        </div>
        <p className="page__intro">Guías y contenido evergreen para saber qué leer a continuación.</p>

        <div className="section-heading">
          <h2>Viajes literarios</h2>
          <Link to="/viajes-literarios">Ver destinos →</Link>
        </div>
        <p className="page__intro">Librerías, ferias, rutas y ciudades vinculadas a autores y novelas.</p>

        <div className="section-heading">
          <h2>Entre Páginas, el podcast</h2>
          <Link to="/podcast">Escuchar episodios →</Link>
        </div>
        <p className="page__intro">Conversaciones sobre libros, autores y viajes literarios.</p>

        <div className="section-heading">
          <h2>Trabaja conmigo</h2>
          <Link to="/trabaja-conmigo">Ver colaboraciones →</Link>
        </div>
        <p className="page__intro">
          Reseñas, contenido y campañas para editoriales, escritores, agencias y marcas.
        </p>
      </div>
    </div>
  );
}

export default Home;
